import React, { useState } from 'react';
import { reportAPI } from '../../services/api';
import { useTranslation } from 'react-i18next';
import './ReportFeedback.css';

interface ReportFeedbackProps {
  reportId: number;
  initialFeedback: string | null;
  onFeedbackChange?: (feedback: string | null) => void;
}

const ReportFeedback: React.FC<ReportFeedbackProps> = ({
  reportId,
  initialFeedback,
  onFeedbackChange,
}) => {
  const [feedback, setFeedback] = useState<string | null>(initialFeedback);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { t } = useTranslation('reports');

  const handleFeedback = async (value: 'like' | 'dislike') => {
    if (isSubmitting) return;

    const newValue = feedback === value ? null : value;

    setIsSubmitting(true);
    try {
      await reportAPI.setFeedback(reportId, newValue);
      setFeedback(newValue);
      onFeedbackChange?.(newValue);
    } catch (error) {
      console.error('Error setting feedback:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="report-feedback">
      {feedback === null && (
        <span className="report-feedback-label">{t('view.feedback_like')}?</span>
      )}
      <button
        className={`report-feedback-btn${feedback === 'like' ? ' active like' : ''}`}
        onClick={() => handleFeedback('like')}
        disabled={isSubmitting}
        title={t('view.feedback_like')}
      >
        <i className="fas fa-thumbs-up"></i>
      </button>
      <button
        className={`report-feedback-btn${feedback === 'dislike' ? ' active dislike' : ''}`}
        onClick={() => handleFeedback('dislike')}
        disabled={isSubmitting}
        title={t('view.feedback_dislike')}
      >
        <i className="fas fa-thumbs-down"></i>
      </button>
    </div>
  );
};

export default ReportFeedback;
